import * as React from "react"
import { cn } from "@/lib/utils"

export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "default" | "destructive" | "outline" | "secondary" | "ghost" | "link"
  size?: "default" | "sm" | "lg" | "icon"
}

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, variant = "default", size = "default", ...props }, ref) => {
    return (
      <button
        className={cn(
          "inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-emerald-950 disabled:pointer-events-none disabled:opacity-50",
          {
            "bg-emerald-600 text-white shadow hover:bg-emerald-700": variant === "default",
            "bg-red-500 text-white shadow-sm hover:bg-red-600": variant === "destructive",
            "border border-emerald-200 bg-white shadow-sm hover:bg-emerald-100 hover:text-emerald-900": variant === "outline",
            "bg-emerald-100 text-emerald-900 shadow-sm hover:bg-emerald-200": variant === "secondary",
            "hover:bg-emerald-100 hover:text-emerald-900": variant === "ghost",
            "text-emerald-900 underline-offset-4 hover:underline": variant === "link",
          },
          {
            // Compact mobile-first sizing
            "h-8 sm:h-9 px-3 sm:px-4 py-1.5 sm:py-2": size === "default",
            "h-7 sm:h-8 rounded-md px-2.5 sm:px-3 text-xs": size === "sm",
            "h-9 sm:h-10 rounded-md px-6 sm:px-8": size === "lg",
            "h-8 sm:h-9 w-8 sm:w-9": size === "icon",
          },
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)
Button.displayName = "Button"

export { Button }
